import React, {useEffect, useState} from "react";
import P from "../lib/P";
import Div from "../lib/Div";
import {getTimeLeft} from "../utils";
import {isFullSwing} from "../constants";

type Props = {
  bg: string, restrictEntry: number, inFocus?: boolean, entrybegindate: number,
  expirationdate: number, message: string
};

const TournamentHelperText = (props: Props) => {
  const {bg, restrictEntry, inFocus, entrybegindate, expirationdate} = props;
  let {message} = props;
  const [countDown, setCountDown] = useState(1);

  if (message === 'Starts In:') {
    message += ` ${getTimeLeft(entrybegindate)}`;

  } else if (message === 'Ends In:' || message === 'Shots Not Completed. Ends In:' || message === 'Shots Completed. Ends In:') {
    message += ` ${getTimeLeft(expirationdate)}`;
  }

  useEffect(() => {
    if (!inFocus) return;

    const time = setTimeout(() => {
      setCountDown(countDown + 1);
    }, 1000);

    return () => {
      clearTimeout(time);
    };
  }, [inFocus, countDown]);

  return (
    <Div h={18} mb={18} bg={bg}>
      <P ta="center" fw="700" fs={14} lh={18} color={isFullSwing ? 'white' : restrictEntry > 0 ? 'white' : 'black'}>
        {message}
      </P>
    </Div>
  );
};

export default TournamentHelperText;
